import React from 'react';
import PropTypes from 'prop-types';
import { WizardStep } from '@zillow/zrs-rental-applications';
import { Heading, Paragraph } from '@zillow/constellation';

export default function ErrorStep({ id }) {
  return (
    <WizardStep id={id} label="Error" hidden>
      <Heading marginBottom="sm" level={4} as="h2">
        Something went wrong while trying to submit
      </Heading>
      <Paragraph>
        An error occurred while your permission setup was processing. Please try again from your property dashboard
        later.
      </Paragraph>
    </WizardStep>
  );
}

ErrorStep.propTypes = {
  id: PropTypes.string.isRequired,
};
